import * as React from 'react';
import { LazyMotion } from 'framer-motion';
import LocaleWrapper from './Context/LocaleContext';
import ThemeWrapper from './Context/ThemeContext';
import '~src/_styles/styles.scss';
const loadMotionFeatures = ()=>import('~src/components/utils/motion/loadMotionFeatures').then((m)=>m.default);
export const Layout = ({ pageLocale, messages, children })=>{
    return React.createElement(LocaleWrapper, {
        pageLocale: pageLocale,
        messages: messages
    }, React.createElement(ThemeWrapper, null, React.createElement(LazyMotion, {
        features: loadMotionFeatures,
        strict: true
    }, children)));
};
export default Layout;
